import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import TipTheDJ from "../views/TipView.vue";
import TipOverlay from "../views/TipOverlay.vue";
import PageNotFound from "../views/PageNotFound.vue";
import Links from "../views/DjLinks.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/tip/:sessionID?",
    name: "tip",
    component: TipTheDJ,
  },
  {
    path: "/tipOverlay",
    name: "tipOverlay",
    component: TipOverlay,
    meta: {
      hideHeaderFooter: true,
    },
  },
  {
    path: "/links",
    name: "Links",
    component: Links,
    meta: {
      hideHeaderFooter: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    component: PageNotFound,
    name: "PageNotFound",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return {
        el: to.hash,
        top: 80,
        behavior: "smooth",
      };
    }

    return {
      top: 0,
      left: 0,
    };
  },
});

export default router;
